import { render, staticRenderFns } from "./s_InPersonCompliance.vue?vue&type=template&id=1650580e&scoped=true&"
import script from "./s_InPersonCompliance.vue?vue&type=script&lang=js&"
export * from "./s_InPersonCompliance.vue?vue&type=script&lang=js&"
import style0 from "./s_InPersonCompliance.vue?vue&type=style&index=0&id=1650580e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1650580e",
  null
  
)

export default component.exports